import { combineReducers } from "redux";

import referencePlatformList from "./referencePlatformList";
import fetching from "./fetching";

export default combineReducers({ referencePlatformList, fetching });
